import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, getBatchFetcher } from '~/api/utils'
import type { ApplicantAvailability } from '../types'

type ApplicantAvailabilityWithId = ApplicantAvailability & { id: number }

const applicantAvailabilitiesBatcher = () =>
  getBatchFetcher<ApplicantAvailabilityWithId>(
    'applicantAvailabilities',
    async (ids) => {
      const availabilities = await fetchApiWithToken<ApplicantAvailability[]>({
        method: 'get',
        url: `/v1/applicants/availabilities?id[]=${ids.join('&id[]=')}&itemsPerPage=1000`
      })

      return availabilities.map((availability) => {
        return {
          ...availability,
          id: availability.applicant.id
        }
      })
    }
  )

export const useApplicantAvailability = ({
  applicantId
}: {
  applicantId?: number
}) => {
  return useQuery({
    queryKey: ['applicants', 'availability', applicantId],
    queryFn: () =>
      applicantId
        ? applicantAvailabilitiesBatcher().fetch(applicantId)
        : Promise.resolve(null),
    enabled: !!applicantId,
    staleTime: 1200_000,
    refetchOnWindowFocus: false
  })
}
